module.exports = {
      id: "icon-audio-next-usage",
      viewBox: "0 0 35.504 35.504",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-audio-next",
      toString: function () {
        return this.url;
      }
    }